// ─────────────────────────────────────────────────────────────
//  DATE DE PROBĂ pentru portal (Etapa 1)
//  Acestea sunt înlocuite cu date reale din PostgreSQL la Etapa 2.
//  Pânâ atunci, totul e simulat ca să vedem cum arată portalul.
// ─────────────────────────────────────────────────────────────

// Cont demo pentru testare login (Etapa 1).
// La Etapa 2 verificarea se face real, cu bcrypt, din baza de date.
export const demoLogin = {
  email: "client@firma.ro",
  parola: "demo1234",
};

export const demoClient = {
  numeFirma: "Firma Demo SRL",
  email: "client@firma.ro",
  telefon: "0723 000 111",
};

// Mașinile clientului demo. Datele de expirare vor veni din LeaseinDAC.
export const demoMasini = [
  {
    id: "1",
    nrInmatriculare: "B 123 ABC",
    model: "Dacia Duster Hybrid",
    serieSasiu: "UU1HSDA8...4521",
    expira: {
      rca: "2026-06-20",
      itp: "2026-11-15",
      rovinieta: "2026-06-10",
      casco: "2027-01-30",
    },
  },
  {
    id: "2",
    nrInmatriculare: "B 456 DEF",
    model: "Hyundai i30 Wagon",
    serieSasiu: "TMAH3...8890",
    expira: {
      rca: "2026-09-05",
      itp: "2026-07-12",
      rovinieta: "2026-12-01",
      casco: "2026-09-05",
    },
  },
  {
    id: "3",
    nrInmatriculare: "B 789 GHI",
    model: "Kia Ceed SW",
    serieSasiu: "U5YH1...2107",
    expira: {
      rca: "2027-02-18",
      itp: "2027-02-18",
      rovinieta: "2026-08-22",
      casco: "2027-03-10",
    },
  },
];

// Tipurile de solicitări (din discuția cu clientul).
export const tipuriTichete = [
  "Cerere carte mașină",
  "Programare service",
  "Înlocuire mașină",
  "Întrebare contract",
  "Daună / accident",
  "Altele",
];

// Tichete demo (istoric).
export const demoTichete = [
  {
    id: "t1",
    tip: "Programare service",
    masina: "B 123 ABC",
    mesaj: "Aș dori o programare pentru revizia de 30.000 km.",
    status: "rezolvat",
    creatLa: "2026-05-20",
  },
  {
    id: "t2",
    tip: "Cerere carte mașină",
    masina: "B 456 DEF",
    mesaj: "Am nevoie de cartea mașinii pentru o deplasare în străinătate.",
    status: "in_lucru",
    creatLa: "2026-06-01",
  },
];
